const root = document.querySelector("[data-nanzora-entrance]");

if (root) {
  const reducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  const seen = sessionStorage.getItem("nanzora_entrance_seen") === "1";
  let disposeScene = () => {};

  const closeEntrance = () => {
    sessionStorage.setItem("nanzora_entrance_seen", "1");
    root.classList.add("is-leaving");
    window.nanzoraEmit?.("entrance_complete");
    window.setTimeout(
      () => {
        disposeScene();
        root.hidden = true;
        document.body.style.removeProperty("overflow");
        document
          .querySelector(".nanzora-hero h1")
          ?.focus?.({ preventScroll: true });
      },
      reducedMotion ? 10 : 680,
    );
  };

  if (seen) {
    root.hidden = true;
  } else {
    document.body.style.overflow = "hidden";
    root
      .querySelector("[data-nanzora-enter]")
      ?.addEventListener("click", closeEntrance);
    root
      .querySelector("[data-nanzora-skip]")
      ?.addEventListener("click", closeEntrance);

    if (!reducedMotion) {
      import("./experience/door-scene.js")
        .then(({ createDoorScene }) => {
          disposeScene = createDoorScene(
            root.querySelector("canvas"),
            closeEntrance,
          );
          root.classList.add("is-webgl");
        })
        .catch(() => root.classList.add("is-fallback"));
    }
  }
}
